import { render, staticRenderFns } from "./contentRepeatDetail.vue?vue&type=template&id=445a44c6&scoped=true"
import script from "./contentRepeatDetail.vue?vue&type=script&lang=js"
export * from "./contentRepeatDetail.vue?vue&type=script&lang=js"
import style0 from "./contentRepeatDetail.vue?vue&type=style&index=0&id=445a44c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "445a44c6",
  null
  
)

export default component.exports